import createIcon from '../../createIcon';

/**
 * @component @name Outbox
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g0Ljk5QzMuODggMyAzLjAxIDMuOSAzLjAxIDVMMyAxOUMzIDIwLjEgMy44OCAyMSA0Ljk5IDIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVY1QzIxIDMuOSAyMC4xIDMgMTkgM1pNMTkgMTVIMTVDMTUgMTYuNjYgMTMuNjUgMTggMTIgMThDMTAuMzUgMTggOSAxNi42NiA5IDE1SDQuOTlWNUgxOVYxNVpNOCAxMUgxMFYxNEgxNFYxMUgxNkwxMiA3TDggMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Outbox = createIcon('Outbox', [
  [
    'path',
    {
      d: 'M19 3H4.99C3.88 3 3.01 3.9 3.01 5L3 19C3 20.1 3.88 21 4.99 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 15H15C15 16.66 13.65 18 12 18C10.35 18 9 16.66 9 15H4.99V5H19V15ZM8 11H10V14H14V11H16L12 7L8 11Z',
      key: 'suu0s4',
    },
  ],
]);

export default Outbox;
